import { observer } from 'mobx-react';

import styles from './TranslationEditor.module.scss';

import { TranslationsData } from 'chaika-frontend-types/frontend-cms';

import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { TranslationEditorItem } from './TranslationEditorItem';
import { useTranslationEditor } from './hooks/useTranslationEditor';
import { translate } from '@chaika/i18n/helper';

interface Props {
    value: TranslationsData[];
    dataTest?: string;
    onChange(params: any): void;
}

export const TranslationEditor = observer(({ dataTest, value, onChange }: Props) => {
    const { options, selectedTranslations, languagesList, onItemChange, onDelete } = useTranslationEditor({
        onChange,
        value,
    });

    return (
        <div className={styles.root}>
            {selectedTranslations.length > 0 && (
                <div className={styles.langs}>
                    {selectedTranslations.map((item, index) => (
                        <TranslationEditorItem
                            key={`${dataTest}_${item.locale}`}
                            item={item}
                            onDelete={() => onDelete(index)}
                            options={options}
                            selectedIds={selectedTranslations.map(item => item.locale)}
                            dataTest={`${dataTest}_${item.locale}`}
                            onChange={value => onItemChange(value, index)}
                        />
                    ))}
                </div>
            )}
            {selectedTranslations.length < languagesList.length && (
                <div className={styles.button}>
                    <Button
                        disabled={selectedTranslations.length > 0 && !!selectedTranslations.find(item => !item.locale)}
                        theme={ButtonTheme.Secondary}
                        modifiers={[ButtonModifiers.Small, ButtonModifiers.InheritWidth]}
                        dataTest={`${dataTest}_add`}
                        label={`+ ${translate('addAnotherLanguage')}`}
                        onClick={() => onItemChange({}, selectedTranslations.length)}
                    />
                </div>
            )}
        </div>
    );
});
